import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const CustomDevicesApi = createApi({
  reducerPath: "CustomDevices",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/vehicles/users`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getAllCustomDevices: builder.query({
      query: () => "/devices/all",
    }),
  }),
});

export const { useGetAllCustomDevicesQuery } = CustomDevicesApi;
